import axios from 'axios';
import {
  COLLECTIONS_UPDATE_FILTER_DETAILS_BEGIN,
  COLLECTIONS_UPDATE_FILTER_DETAILS_SUCCESS,
  COLLECTIONS_UPDATE_FILTER_DETAILS_FAILURE,
  COLLECTIONS_UPDATE_FILTER_DETAILS_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function updateFilterDetails(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_UPDATE_FILTER_DETAILS_BEGIN,
    });
    const { projectId, collectionUuid, filterUuid, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/finders/${collectionUuid}/collection/${filterUuid}/filter`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_UPDATE_FILTER_DETAILS_SUCCESS,
            data: res.data,
          });
          toast.success('Updated Successfully !');
          resolve(res);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_UPDATE_FILTER_DETAILS_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Updation Failed: ${errMsg}` || 'Updation Failed !');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateFilterDetailsError() {
  return {
    type: COLLECTIONS_UPDATE_FILTER_DETAILS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_UPDATE_FILTER_DETAILS_BEGIN:
      return {
        ...state,
        updateFilterDetailsPending: true,
        updateFilterDetailsError: null,
      };

    case COLLECTIONS_UPDATE_FILTER_DETAILS_SUCCESS:
      let projectCollections = state.projectCollections;
      let index = projectCollections.findIndex(function (item, i) {
        return item._id === action.data._id;
      });
      projectCollections[index] = action.data;
      return {
        ...state,
        updateFilterDetailsPending: false,
        updateFilterDetailsError: null,
        projectCollections,
        selectedCollection: action.data,
      };

    case COLLECTIONS_UPDATE_FILTER_DETAILS_FAILURE:
      return {
        ...state,
        updateFilterDetailsPending: false,
        updateFilterDetailsError: action.data.error,
      };

    case COLLECTIONS_UPDATE_FILTER_DETAILS_DISMISS_ERROR:
      return {
        ...state,
        updateFilterDetailsError: null,
      };

    default:
      return state;
  }
}
